<template>
  <ul class="partners-list">
    <li
      v-for="item in items"
      :key="item.id"
      class="partners-list__item"
    >
      <atomic-image
        class="img"
        :src="item.src"
        :alt="item.id"
      />
      <span class="visually-hidden">{{ item.id }}</span>
    </li>
  </ul>
</template>

<script setup lang="ts">
const PARTNERS = ['partner1', 'partner2', 'partner3', 'partner4', 'partner5'];

const items = PARTNERS.map(item => ({
  id: item,
  src: `/img/partners/${item}.svg`,
}));
</script>

<style src="~/assets/styles/components/list/partners.scss" lang="scss" />
